// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select fieldset legend {
  height: fit-content !important;
}

.custom-select fieldset legend span {
  opacity: 1 !important;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/repsandsets/Index.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".custom-select fieldset legend {\n  height: fit-content !important;\n}\n\n.custom-select fieldset legend span {\n  opacity: 1 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
